import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { useSettings } from '@/hooks/useSettings';

export default function Impressum() {
  const { settings } = useSettings();

  return (
    <div data-testid="impressum-page">
      <Navbar settings={settings} />
      <main className="pt-28 pb-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 uppercase tracking-tight mb-10">Impressum</h1>

          <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase mt-0">Angaben gemäß § 5 TMG</h2>
            <p>
              HKE Bedachung Ertel<br />
              Inhaber: Andreas Ertel<br />
              Teichplatz 7<br />
              01259 Dresden
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">Kontakt</h2>
            <p>
              Telefon: 0351-2038530<br />
              Mobil: 0171-7714831<br />
              E-Mail: hke-bedachung@t-online.de
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">Berufsbezeichnung</h2>
            <p>
              Dachdeckermeister<br />
              Zuständige Kammer: Handwerkskammer Dresden<br />
              Verliehen in: Deutschland
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">Angaben zur Berufshaftpflichtversicherung</h2>
            <p>
              Die Angaben zur Berufshaftpflichtversicherung können beim Betrieb erfragt werden.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0077D4] hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
